module.exports = __webpack_public_path__ + "static/media/33-6.af54e90e.mp3";